<template>
  <div>
    <h1>{{location}}</h1>
    <div v-if="table && table.length === 0">
      <p>
        No Data for selected period
      </p>
    </div>
    <div v-else-if="isLoading === true">
      <p>
        Loading...
      </p>
    </div>
    <div v-else-if="!isLoading && table && table.length !== 0">
      <!-- {{table}} -->

      <BasicTableComponent 
        :list="table" 
        tableClass="table2excel"
        :tableID="location"
        :formatters="{
          'date' : ['d', 'ddd MM/DD/YY'], 
          'Interac_#' :  ['n', '0,0'],
          'VISA_#' :  ['n', '0,0'],
          'M/C_#' :  ['n', '0,0'],
          'Amex_#' :  ['n', '0,0'],
          'Discovery_#' :  ['n', '0,0'],
        }"
        :titles="{
          'M/C_amount' : 'M/C Amount', 
          'M/C_#' : 'M/C #', 
        }"
      />
    </div>  
  </div>
</template>

<script>
export default {
  name: 'POSReconcilliationTable',
  inject:['page'],
  props:['location'],
  computed:{
    posStore(){return this.page.$refs.posStore},
    shiftStore(){return this.page.$refs.shiftStore},
    keys(){return this.$util.keys(this.table)},
    isLoading(){
      // if(!this.posStore.data[this.location] && !this.shiftStore.data[this.location])
      //   return true;
      let result = this.posStore.data[this.location].isLoading || this.shiftStore.data[this.location].isLoading;
      result = result || !this.posStore.data[this.location].pos || !this.shiftStore.data[this.location].shifts
      return result
    },
    table(){
      if (this.isLoading)
        return;
      const posData = this.posStore.pivotData(this.location);
      let shiftsData = this.shiftStore.pivotedData[this.location].shifts;
      shiftsData = this.$math.subtotalsForKey(shiftsData, 'day')

      console.log('POSRec DEBUG posData', this.$util.valuesForKeyPath(posData, 'date'))
      console.log('POSRec DEBUG shiftsData', this.$util.valuesForKeyPath(shiftsData, 'day'))

      // let t = posData;
      // console.log('table',this.location, this.shiftStore.pivotedData[this.location].shifts, this.posStore.pivotData(this.location))
      // let t = this.$util.joinArrayToOne(this.shiftStore.pivotedData[this.location].shifts, this.posStore.pivotData(this.location), 'day', 'date');
      let t = shiftsData;
      
      // const calculatedCols = (r) => {
      //   const Start = moment(r.StartDateTime).subtract(this.startBuffer || 10, 'minutes').toDate()
      //   const End = moment(r.EndDateTime).add(this.endBuffer || 10, 'minutes').toDate()
      //   const Hours = moment.duration(moment(End).diff(moment(Start), 'seconds'), 'seconds').asHours()
      //   const RoundedHours = parseFloat((Math.round(Hours * 4) / 4).toFixed(2));
      //   return {Start, End, Hours, RoundedHours}
      // }
      // t = t.map(r=> ({...r, ...calculatedCols(r)})) 
      // console.log('POSRecTable', t)
      return t;
      
    },
    filteredTable(){
      if (this.isLoading)
        return;
      return this.table.filter(r=>(r.cashier || "").toLowerCase().includes(this.filter.toLowerCase()));
    },
    totals(){
      if (this.isLoading)
        return;
      let totals = this.$math.sumKeys(this.filteredTable) 
      totals = this.$util.deleteObjectProperties(totals, ['StartDateTime', 'EndDateTime', 'Start', 'End'])
      totals.day = 'Total'
      return [totals]
    },
    subtotals(){
      if (this.isLoading)
        return;
      let subtotals = this.$math.subtotalsForKey(this.filteredTable, 'cashier')
      subtotals = this.$util.deleteObjectProperties(subtotals, ['day', 'StartDateTime', 'EndDateTime', 'Start', 'End'])
      return subtotals
    },
  },
}
</script>